<div
  class="input-search"
  [class.condensed]="condensed()"
>
  <mat-form-field
    floatLabel="always"
    appearance="outline"
    subscriptSizing="dynamic"
    [hidden]="showMode()"
  >
    @if (label() && !condensed()) {
      <mat-label>
        {{ label() }}
        @if (isRequired && !showMode()) {
          <span class="input-required"> * </span>
        }
      </mat-label>
    }
    <input
      matInput
      autocomplete="off"
      [id]="id() ?? ''"
      [placeholder]="controlPlaceholder"
      [formControl]="control()"
      [type]="type()"
      (keyup.enter)="onSearch()"
      (input)="onSearch()"
    />
    @if (showClear) {
      <button
        class="clear-button"
        type="button"
        aria-label="Clear search"
        mat-icon-button
        matSuffix
        (click)="clear()"
      >
        <mat-icon>clear</mat-icon>
      </button>
    } @else {
      <mat-icon matSuffix>
        {{ icon() }}
      </mat-icon>
    }
  </mat-form-field>
</div>
